import MuiAvatar from '@mui/material/Avatar';
import type { ReactNode } from 'react';

export interface AvatarProps {
  src?: string;
  children?: ReactNode;
}

export function Avatar({ src, children }: AvatarProps) {
  return <MuiAvatar {...(src !== undefined ? { src } : {})}>{children}</MuiAvatar>;
}
